module.exports = {"checkCoverage":"Verificar cobertura","title":"Confirme se a NOWO já está na sua zona.","subTitle":"Indique a sua morada e verifique se tem cobertura.","placeholder":"Morada ou Código Postal","cantFindAddress":"Não encontra a sua morada?","returnToSimulator":"Voltar ao simulador"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/pt/coverage.json
// module id = itZL
// module chunks = 64